import { PLAY_SITE_BASE } from 'constants/play';

/** Decision 3: invite links are trademagic.gg/play/{code}. */
export const inviteUrl = (code: string): string => `${PLAY_SITE_BASE}/play/${code}`;

/** The link as shown on the lobby card and in share copy, without the scheme. */
export const inviteUrlDisplay = (code: string): string => inviteUrl(code).replace(/^https?:\/\//, '');

export const playPath = (code: string, sub?: 'live' | 'standings' | 'deck' | 'report' | 'host'): string =>
  sub ? `/play/${code}/${sub}` : `/play/${code}`;
